import { BaseElement, defineElement } from "./lib-element-js.min.js";

class FadeComponent extends BaseElement {
  index = 0;
  height = 0;
  interval;

  connected() {
    this.activate();
    window.addEventListener("resize", () => {
      this.activate();
    });
  }

  properties() {
    return {
      active: false,
    };
  }

  activate() {
    if (this.children.length <= 1) return;

    let maxWidth = 749;
    if (this.fadeOnDesktop) maxWidth = 999999999999999999;

    if (this.active && window.innerWidth > maxWidth) {
      this.destroy();
    }
    if (this.active) return;

    if (window.innerWidth <= maxWidth) {
      this.active = true;
      this.init();
      this.autoPlay();
    }
  }

  init() {
    const offsetHeight = this.children[0].offsetHeight;
    this.height = offsetHeight;
    this.style.height = `${offsetHeight}px`;

    for (let child of this.children) {
      child.style.position = "absolute";
      child.style.opacity = 0;
    }
  }

  autoPlay() {
    this.fadeIn();

    this.interval = setInterval(() => {
      this.index++;
      if (this.children.length <= this.index) this.index = 0;

      this.fadeOut();
      setTimeout(() => {
        this.fadeIn();
      }, 500);
    }, 3000);
  }

  fadeOut() {
    for (let child of this.children) {
      child.style.opacity = 0;
      child.style.zIndex = 0;
    }
  }

  fadeIn() {
    const offsetHeight = this.children[this.index].offsetHeight;

    if (this.height < offsetHeight) {
      this.height = offsetHeight;
      this.style.height = `${offsetHeight}px`;
    }

    if (offsetHeight < this.height) {
      this.children[this.index].style.height = `${this.height}px`;
    }

    this.children[this.index].style.opacity = 1;
    this.children[this.index].style.zIndex = 2;
  }

  destroy() {
    clearInterval(this.interval);
    this.active = false;
    this.style.height = "auto";

    for (let child of this.children) {
      child.style.opacity = 1;
      child.style.position = "relative";
    }
  }
}
defineElement("fw-fade-component", FadeComponent);
